module.exports = __webpack_public_path__ + "img/maajakotit.3852609d.jpg";